import React from "react";
import SectionHeader, { SectionWrapper, Reveal } from "./SectionHeader";

const METRICS = [
  { value: "1B+", label: "Cumulative views", note: "All time · all platforms", color: "#00F0FF", tid: "scale-reach" },
  { value: "1.9M+", label: "Native community", note: "Owned channels", color: "#FF00FF", tid: "scale-community" },
  { value: "1M+", label: "Facebook followers", note: "Primary feed", color: "#FFDE00", tid: "scale-fb" },
  { value: "500K+", label: "YouTube subscribers", note: "Long form", color: "#00F0FF", tid: "scale-yt" },
  { value: "130K+", label: "Instagram followers", note: "Short form", color: "#FFDE00", tid: "scale-ig" },
];

const Card = ({ m, idx }) => (
  <Reveal delay={idx * 0.05}>
    <div
      className="glass-card hud-corners p-6 md:p-8 h-full flex flex-col justify-between min-h-[220px] relative overflow-hidden group"
      data-testid={m.tid}
    >
      <span className="hud-tr" />
      <span className="hud-bl" />
      <div className="flex items-start justify-between">
        <span className="micro-label" style={{ color: m.color }}>
          // {String(idx + 1).padStart(2, "0")}
        </span>
        <span className="micro-label text-white/35">{m.note}</span>
      </div>

      <div>
        <div
          className="font-display font-black stat-num mt-6 interactive-text leading-none"
          style={{ color: m.color, textShadow: `0 0 28px ${m.color}55` }}
        >
          {m.value}
        </div>
        <div className="mt-3 text-white/70 text-sm md:text-base font-body">{m.label}</div>
      </div>

      {/* bottom meter */}
      <div className="mt-6 h-[2px] bg-white/5 overflow-hidden">
        <div
          className="h-full transition-all duration-700 group-hover:w-full"
          style={{
            width: "35%",
            background: `linear-gradient(90deg, ${m.color}, transparent)`,
          }}
        />
      </div>
    </div>
  </Reveal>
);

const ScaleReach = () => {
  return (
    <SectionWrapper id="scale">
      <SectionHeader
        code="// CH.03 — SCALE & REACH"
        title="Reach.Grid"
        kicker="A measurable signal across every major digital surface — not vanity, volume."
        tid="scale"
      />
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
        {METRICS.map((m, i) => (
          <Card key={m.tid} m={m} idx={i} />
        ))}
      </div>

      {/* Bottom ticker */}
      <div className="mt-12 flex flex-wrap items-center justify-between gap-4 micro-label text-white/40 border-t border-cyan-500/10 pt-6">
        <span>SRC · INTERNAL DASHBOARD</span>
        <span>VERIFIED · PLATFORM-WIDE</span>
        <span>LAST SYNC · LIVE</span>
      </div>
    </SectionWrapper>
  );
};

export default ScaleReach;
